// extracted by css-extract-rspack-plugin
export default {"InviteCollaboratorsDrawerView":"sputnik__InviteCollaboratorsDrawerView__zJUWG","inviteCollaboratorsDrawerView":"sputnik__InviteCollaboratorsDrawerView__zJUWG"};